import type { FaireProductEntity } from "../../entity_types/product";

export const p_j5swg3wh65: FaireProductEntity = {
  token: "p_j5swg3wh65",
  type: "product",
  name: "Soul Eater, Vol. 17",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/c7a3e0c2f0beeaaccfd40304176f868dab33170261041db7ade55c0897969379.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "The DWMA student body is still reeling after the news that one of their own is a witch. But as one young witch flees Death City, another has come back to DWMA hoping to strike a deal with Shinigami-sama. Medusa has already proven herself a traitor to the school, but the information she offers is critical to DWMA's efforts to take down Arachnophobia and curb the spread of madness. Can Medusa be trusted to lead a team of students into the heart of enemy territory?!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:21.852Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
